export const useVar = () => {
  const eventId = process.env.REACT_APP_EVENT_ID;
  const miceEventId = parseInt(process.env.REACT_APP_EVENT_ID_MICE ?? '172861');
  const accountId = process.env.REACT_APP_ACCOUNT_ID;
  const testMode = process.env.REACT_APP_TEST_MODE == 1 ? true : false;
  return { eventId, accountId, testMode, miceEventId };
};
